import { useState, useEffect } from "react";
import { Container, StyledReactModal } from "./style";
import Button from "components/particles/primary-button";
import { usePrecookingSetups } from "containers/setting/CMS/precooking-setup/useHook";
import { PrecookingSetupDTO } from "utils/helpers/models/precookingSetup.dto";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import close from "assets/images/close.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface AddPrecookingSetupPopupProps {
  id: number;
  data?: any;
}

export default function AddPrecookingSetupPopup({ id, data }: AddPrecookingSetupPopupProps) {
  const [formData, setFormData] = useState<PrecookingSetupDTO>({
    preCookingSetUp: "",
    status: true,
  });

  const [content, setContent] = useState({
    description: "",
  });

  const { postPrecookingSetup } = usePrecookingSetups();
  const { precookingSetupModalIsOpen } = useSelector(
    (state: RootState) => state.user
  );

  function closeModal() {
    dispatch(setModalClosed("Precooking Setup"));
  }

  useEffect(() => {
    if (data && id !== 0) {
      setFormData({
        preCookingSetUp: data.preCookingSetUp || "",
        status: data.status !== undefined ? data.status : true,
      });
      setContent({
        description: data.preCookingSetUp || "",
      });
    } else {
      setFormData({
        preCookingSetUp: "",
        status: true,
      });
      setContent({
        description: "",
      });
    }
  }, [data, id]);

  const handleInputChange = (field: keyof PrecookingSetupDTO, value: string | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent default form submission

    if (!content.description.trim()) {
      alert("Please enter content for the precooking setup");
      return;
    }

    try {
      // Use content.description as the preCookingSetUp value
      const finalRequestBody = id === 0
        ? { ...formData, preCookingSetUp: content.description, id: undefined }
        : { ...formData, preCookingSetUp: content.description, id };
      await postPrecookingSetup(finalRequestBody);
    } catch (error) {
      console.error("Error saving precooking setup:", error);
    }
  };

  return (
    <StyledReactModal
      isOpen={precookingSetupModalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Precooking Setup Modal"
    >
      <button className="close-button" onClick={closeModal}>
        <img src={close} alt="img" />
      </button>
      <Container onSubmit={handleSubmit}>
        <div className="model-container">
          <div className="popup-title">
            <h1>{id === 0 ? "Add Precooking Setup" : "Update Precooking Setup"}</h1>
          </div>
          <div className="add-ingredient-container">
            <ReactQuill
              theme="snow"
              value={content.description}
              onChange={(value) => setContent({ ...content, description: value })}
              className="text-editor"
              modules={quillModules}
              placeholder="Enter precooking setup description..."
            />
          </div>
          <div className="add-button">
            <Button
              title={id === 0 ? "Save" : "Update"}
              width="100%"
              backgroundcolor="var(--primary)"
              fill="true"
              type="submit"
            />
          </div>
        </div>
      </Container>
    </StyledReactModal>
  );
}
